import { userJourneyApis } from '@shared/apis';
import { genericQueryWithId } from './generics';

export const useGetUserJourney = genericQueryWithId<userJourneyApis.GetUserJourney>(
  userJourneyApis.getUserJourney
);
